import React, { Component } from 'react'

// import * as FullStory from '@fullstory/browser'
import * as Sentry from '@sentry/react'
import { withTheme } from 'components'
import compose from 'lodash/fp/compose'

import ErrorPage from './components/errorBoundary/components/ErrorPage'
import withGraphQL from './components/hocs/withGraphQL'
import withOverriddenTheme from './components/hocs/withOverriddenTheme'
import Routes from './routes'
import errorService from './utils/analytics/error'
import { initializeGlobalTabIconRemoval } from './utils/removeTabIcon/index'

// FullStory.init({ orgId: process.env.REACT_APP_FULLSTORY_ORGID })

class App extends Component {
  // Initialize cleanup function as class property
  tabIconCleanup = null

  componentDidMount() {
    errorService.configure()

    // Initialize global tab icon removal for accessibility compliance
    this.tabIconCleanup = initializeGlobalTabIconRemoval()
  }

  componentWillUnmount() {
    // Clean up the tab icon removal observer
    if (this.tabIconCleanup) {
      this.tabIconCleanup()
    }
  }

  render() {
    return (
      <Sentry.ErrorBoundary fallback={() => <ErrorPage />}>
        <Routes />
      </Sentry.ErrorBoundary>
    )
  }
}

const withEnhancers = compose(withGraphQL, withTheme, withOverriddenTheme)

export default Sentry.withProfiler(withEnhancers(App), { name: 'GOGE' })
